export const DOCUMENT_DIRECTION = {
  Inbound: 0,
  Outbound: 1,
}

export const VAT_RECORDING_DOCTYPE = {
  Invoice: 380,
  CreditNote: 381,
  DebitNote: 383,
  PrepaymentInvoice: 386,
  InternalAccountForTurnoverOfForeigner: 400,
  OtherInternalStatement: 401,
}

export const INTERNAL_INVOICE_OPTION = {
  Turnover: 1,
  Prepayment: 2,
  Debit: 3,
  Credit: 4,
}

export const RELATED_INVOICE_OPTION = {
  Empty: 0,
  Invoice: 1,
  PeriodSelection: 2,
  Prepayment: 3,
}

export const RELATED_INTERNAL_INVOICE_OPTION = {
  Empty: 0,
  InternalAccountForTurnover: 1,
  InternalAccountForPrepayment: 2,
}

export const EMPTY_VALUE_PLACEHOLDER = '--'

export const FIELD_MAPPER_OBJECT_PAIRS = {
  relatedInvoiceOption: RELATED_INVOICE_OPTION,
  internalInvoiceOption: INTERNAL_INVOICE_OPTION,
  relatedInternalInvoiceOption: RELATED_INTERNAL_INVOICE_OPTION,
}
export const DATE_FIELDS_TO_FORMAT = [
  'paymentDate',
  'prepaymentDate',
  'relatedInvoiceIssueDateFrom',
  'relatedInvoiceIssueDateTo',
]

export const NUMBER_FIELDS_TO_FORMAT = [
  'noRealEstateBaseAmount20',
  'noRealEstateCalculatedVat20',
  'noRealEstateBaseAmount10',
  'noRealEstateCalculatedVat10',
  'realEstateBaseAmount20',
  'realEstateCalculatedVat20',
  'realEstateBaseAmount10',
  'realEstateCalculatedVat10',
  'noChargeNoRealEstateBaseAmount20',
  'noChargeNoRealEstateCalculatedVat20',
  'noChargeNoRealEstateBaseAmount10',
  'noChargeNoRealEstateCalculatedVat10',
  'noChargeRealEstateCalculatedVat20',
  'noChargeRealEstateBaseAmount20',
  'noChargeRealEstateBaseAmount10',
  'noChargeRealEstateCalculatedVat10',
  'noChargeNoRealEstateBaseAmount20',
  'noChargeNoRealEstateCalculatedVat20',
]
